module.exports = __webpack_public_path__ + "static/media/ui-sales.f19ec147.webp";